import axios from 'axios';

// Login API endpoint'ini environment variable'dan al
const LOGIN_API_URL = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/account/login';

/**
 * Kullanıcı girişi yapmak için API'ye istek atar.
 * @param {string} username Kullanıcı adı (veya email)
 * @param {string} password Şifre
 * @returns {Promise<object>} Başarılı olursa API'den dönen veri objesini döner.
 * @throws {Error} İstek başarısız olursa veya ağ hatası olursa hata fırlatır.
 */
export const loginUser = async (username, password) => {
    if (!LOGIN_API_URL) {
        throw new Error("Giriş yapılandırması eksik.");
    }

    try {
        const response = await axios.post(LOGIN_API_URL, {
            username: username,
            password: password,
        });
        // API { isSuccess, data, message, error } yapısında dönüyor
        const result = response.data;
        if (result && result.isSuccess && result.data) {
            return result.data; // İç data objesini döndür (token, userId, roles vb.)
        }
        throw new Error(result?.message || 'Giriş başarısız.');
    } catch (error) {
        // Axios hatalarını daha anlaşılır hale getirelim
        if (error.response) {
            // API'den yanıt geldi ama status 2xx değil (örn. 401, 400)
            const apiErrorData = error.response.data;
            const errorMessage = apiErrorData?.message || apiErrorData?.detail || 'Giriş başarısız. Sunucudan hata mesajı alınamadı.';
            throw new Error(errorMessage); // API'den gelen veya genel bir hata mesajı fırlat
        } else if (error.request) {
            // İstek yapıldı ama yanıt alınamadı (ağ hatası, sunucu kapalı vb.)
            throw new Error('API sunucusuna ulaşılamadı. Ağ bağlantınızı kontrol edin.');
        } else {
            // İsteği ayarlarken bir hata oluştu
            throw new Error('Giriş isteği gönderilirken bir hata oluştu.');
        }
    }
};

export const setAuthSession = (data) => {
    if (!data) return;

    const token = data.accessToken || data.token;
    if (token) {
        localStorage.setItem('accessToken', token);
    }

    if (data.expiration) {
        localStorage.setItem('sessionExpiration', data.expiration);
    }

    if (data.fullName) {
        localStorage.setItem('userFullName', data.fullName);
    }

    if (data.roles && Array.isArray(data.roles) && data.roles.length > 0) {
        localStorage.setItem('userRole', data.roles[0]);
    } else if (data.roles && Array.isArray(data.roles) && data.roles.length === 0) {
        localStorage.setItem('userRole', 'Kullanıcı');
    }

    if (data.userId) {
        localStorage.setItem('userId', data.userId);
    }

    if (data.username) {
        localStorage.setItem('username', data.username);
    }

    if (data.email) {
        localStorage.setItem('email', data.email);
    }

    localStorage.setItem('login', JSON.stringify(true));
    window.dispatchEvent(new CustomEvent('userRoleChanged'));
    window.dispatchEvent(new CustomEvent('sessionChanged'));
};

export const getSessionExpiration = () => localStorage.getItem('sessionExpiration');

export const isSessionExpired = () => {
    const expiration = getSessionExpiration();
    const token = localStorage.getItem('accessToken');
    if (!token && !expiration) return false;
    if (!expiration) return true;
    const expirationTime = new Date(expiration).getTime();
    if (Number.isNaN(expirationTime)) return true;
    return expirationTime <= Date.now();
};

/**
 * Kullanıcı çıkışı yapar. localStorage'ı temizler ve rol değişikliği event'ini tetikler.
 */
export const logoutUser = () => {
    // LocalStorage'ı temizle
    localStorage.removeItem('profileURL');
    localStorage.removeItem('token');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('Name');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('userRole');
    localStorage.removeItem('login');
    localStorage.removeItem('sessionExpiration');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    localStorage.removeItem('email');
    
    // Rol değişikliği event'ini tetikle
    window.dispatchEvent(new CustomEvent('userRoleChanged'));
    window.dispatchEvent(new CustomEvent('sessionChanged'));
};

// İleride buraya diğer auth ile ilgili servis fonksiyonları eklenebilir
// export const registerUser = async (...) => { ... };
// export const forgotPassword = async (...) => { ... };